module.exports = __webpack_public_path__ + "static/media/boss-item-block.85962d6b.png";